import { RecordContent, RecordFooter, useTitleChange } from '@msaf/core-react'
import { useEffect, useState } from 'react'
import { WellDrinkingWaterFieldsView } from '../../../../../types/form-types'
import WellDrinkingWaterView from '../../../../components/well-forms/drinking-water/drinking-water-view'
import NotesWrapperView from '../../../../components/well-forms/notes/notes-wrapper-view'
import WellViewButtons from '../../../../components/wells/well-view-buttons'
import { useGetWellData } from '../../../../hooks/use-api'
import { useWellId } from '../../../../hooks/use-well-id'

export default function ViewWellDrinkingWater() {
  useTitleChange('View Well | Drinking Water')
  const id = useWellId()
  const url = `wells/${id}/drinking-water/view`
  const [fields, setFields] = useState<Partial<WellDrinkingWaterFieldsView>>({})
  const { isLoading, isSuccess, data } = useGetWellData(url)
  useEffect(() => {
    if (isSuccess && data.state) {
      setFields(data.state)
    }
  }, [isSuccess, data])

  return (
    <>
      <RecordContent>
        <WellDrinkingWaterView fields={fields} isLoading={isLoading} />
      </RecordContent>

      <RecordFooter
        notes={
          Array.isArray(fields.notes) &&
          !!fields.notes.length && <NotesWrapperView notes={fields.notes} isLoading={isLoading} />
        }
        areActionsFixed={true}
      >
        <WellViewButtons wellId={id} />
      </RecordFooter>
    </>
  )
}
